module.exports = __webpack_public_path__ + "static/media/DigiNanny and Banking.dfe19366.png";